import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {DoNotDisturbOnRounded, EditRounded} from '@mui/icons-material'

export const StyledScrollableBox = styled(Box)({
  minHeight: 0
})

export const StyledDetailsBox = styled(Box)(() => ({
  flexGrow: 1
}))

export const StyledErrorIcon = styled(DoNotDisturbOnRounded)(({theme}) => ({
  color: theme.palette.hpErrorRed,
  fontSize: theme.typography.h2.fontSize
}))

export const StyledEditIcon = styled(EditRounded)(({theme}) => ({
  fontSize: theme.typography.pxToRem(18)
}))

export const StyledRemoveIcon = styled(DoNotDisturbOnRounded)(({theme}) => ({
  fontSize: theme.typography.pxToRem(18)
}))

export const StyledRemoveButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.hpErrorRed,
  '&:hover': {
    backgroundColor: theme.palette.hpErrorRedHover,
    border: 'none'
  }
}))

export const StyledChip = styled(Chip)(({theme}) => ({
  backgroundColor: theme.palette.warning.light,
  color: theme.palette.warning.main
}))

export const StyledInfoHeading = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightSemibold
}))

export const StyledAdminGroupHeading = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightSemibold
}))

export const StyledRemoveUserTitle = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold
}))

export const StyledFlexCenterRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
})

export const StyledFlexRow = styled(Box)({
  display: 'flex',
  gap: '8px'
})

export const StyledFormContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingTop: '10px'
})

export const StyledActionButtonsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
  marginTop: '16px'
})

export const StyledEditFeedbackText = styled(Typography)(({theme}) => ({
  marginTop: '-10px',
  marginBottom: '10px',
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.subtitle1.fontSize
}))
